import {constant, defaultTo, equals, firstOf, flow, get, groupBy, ifThen} from '@yandex-delivery/utils'

import {type SectionProps as Props, type SlotWidgetConfig, type WidgetConfig, WidgetType} from '../types'

type ParcelWidgets = {
  headers: SlotWidgetConfig[]
  parcelSize: SlotWidgetConfig[]
  whatsInside: SlotWidgetConfig[]
  content: SlotWidgetConfig[]
}
type ParcelType = keyof ParcelWidgets

const isHeaderWidget: (widget: SlotWidgetConfig) => boolean = flow(get('accessibility_info.is_header'), equals(true))
const isItemFirstWidget: (widget: SlotWidgetConfig) => boolean = flow(
  get('widget_id'),
  equals('cargo_c2c_order_forms_b2b_lk_ndd_self_pickup_size_switch_widget'),
)
const isItemSecondWidget: (widget: SlotWidgetConfig) => boolean = flow(
  get('widget_id'),
  equals('cargo_c2c_order_forms_b2b_lk_what_inside_dropdown_list_widget'),
)

const byParcelType: (widget: WidgetConfig) => ParcelType = flow(
  firstOf(
    ifThen(isHeaderWidget, constant<ParcelType>('headers')),
    ifThen(isItemFirstWidget, constant<ParcelType>('parcelSize')),
    ifThen(isItemSecondWidget, constant<ParcelType>('whatsInside')),
  ),
  defaultTo<ParcelType>('content'),
)

export const groupByOptionType: (props: Props) => ParcelWidgets = flow(
  get('section.widgets'),
  groupBy(byParcelType) as unknown as (w: WidgetConfig[]) => ParcelWidgets,
)

export const toHeader = (header: SlotWidgetConfig): SlotWidgetConfig => {
  return {
    ...header,
    slot: {
      ...header.slot,
      lead: {
        icon_spot: {
          icon: {
            image_tag: 'delivery_form_box_fill',
            tint_color: 'text',
          },
          background_color: 'controlMinor',
        },
        type: WidgetType.ICON_SPOT,
      },
    },
  }
}
